<template>
  <BaseModal
    :title="$t('Project settings')"
    :tabs="settingsTabs"
    :current-tab-id="currentTab"
    @change-tab="currentTab = $event"
  >
    <Spinner v-if="$apollo.loading || !settingsData" size="48" />
    <ProjectSettingsForm
      v-else-if="currentTab === 1"
      :settings="settingsData"
      :create-form="context.createForm"
      @create="createAct"
      @update="updateProject"
    />
    <ProjectCurrencyForm
      v-else-if="currentTab === 2"
      :settings="settingsData"
      :create-form="context.createForm"
    />
    <ProjectTeammatesForm v-else-if="currentTab === 3" />
  </BaseModal>
</template>

<script>
  import ProjectSettingsForm from '@/containers/top-menu/header/project-settings/Form';
  import projectSettingsQuery from '@/gql/estimate/project-settings.graphql';
  import Spinner from 'vue-simple-spinner';
  import BaseModal from '@/components/ui/BaseModal';
  import { mapActions, mapState } from 'vuex';
  import ProjectCurrencyForm from '@/containers/project/ProjectCurrencyForm';
  import ProjectTeammatesForm from '@/containers/project/ProjectTeammatesForm';

  export default {
    name: 'ProjectSettingsModal',
    components: {
      Spinner,
      ProjectSettingsForm,
      BaseModal,
      ProjectCurrencyForm,
      ProjectTeammatesForm,
    },
    props: {
      context: {
        type: Object,
        /** {
         *  createForm: boolean // is this the modal for the first act-form creation
         *  projectId: number,
         *  endAction: () => () // function to use after successful settings submission
        } */
        default: () => ({
          createForm: Boolean,
          endAction: Function,
          projectId: null,
        }),
      },
    },
    computed: {
      ...mapState('project', ['projectInfo']),
    },
    data() {
      return {
        settingsData: null,
        settingsTabs: [
          { id: 1, text: this.$t('General') },
          { id: 2, text: this.$t('Currency') },
          { id: 3, text: this.$t('Teammates') },
        ],
        currentTab: this.context.step || 1,
      };
    },
    created() {},
    apollo: {
      settings() {
        return {
          query: projectSettingsQuery,
          fetchPolicy: 'no-cache',
          variables() {
            return {
              id: this.context.projectId || this.$route.params.id,
            };
          },
          async update(data) {
            // При переходе между проектами иногда старый проект вылезает в настройках нового
            const needToUpdateProjectInfo =
              data.settings?.[0]?.project?.id !== this.projectInfo?.id;
            if (!this.projectInfo || needToUpdateProjectInfo)
              await this.loadProjectInfo({ id: this.context.projectId || this.$route.params.id });
            if (data.settings.length)
              this.settingsData = {
                ...data.settings[0],
                project: {
                  ...data.settings[0].project,
                  ...this.projectInfo,
                },
              };
          },
        };
      },
    },
    methods: {
      ...mapActions('project', ['loadProjectInfo']),
      createAct() {
        this.context?.endAction?.();
      },
      updateProject() {
        this.context?.update?.();
      },
    },
  };
</script>
